<template>
   <ObiModal as="form" ref="modal" @submit.prevent="submitForm">
      <template #header>
         <ObiTitle :icon="IconLayers" icon-stacked :title="$t('title')" :subtitle="$t('subtitle')" />
      </template>
      <ObiRow>
         <ObiCol sm="12">
            <ObiFloatingInput
               compact
               :label="$t('fields.title')"
               :disabled="isLoading"
               :placeholder="$t('fields.title')"
               v-model="formData.title"
               :errors="formData.errors.get('title')"
            />
         </ObiCol>
      </ObiRow>
      <ObiRow class="mt-2">
         <ObiCol sm="12">
            <ObiFloatingInput
               compact
               :label="$t('fields.description')"
               :disabled="isLoading"
               :placeholder="$t('fields.description')"
               v-model="formData.description"
               :errors="formData.errors.get('description')"
            />
         </ObiCol>
      </ObiRow>
      <ObiRow class="mt-2">
         <ObiCol sm="12">
            <ObiFloatingInput
               compact
               :label="$t('fields.prefix')"
               :disabled="isLoading"
               :placeholder="$t('fields.prefix')"
               v-model="formData.prefix"
               :errors="formData.errors.get('prefix')"
            />
         </ObiCol>
      </ObiRow>

      <template slot="actions">
         <ObiButton
            wider
            icon-right
            type="submit"
            :loading="isLoading"
            :text="$t('actions.save')"
            icon="mdi mdi-arrow-right"
         />
      </template>
   </ObiModal>
</template>

<script>
import ErrorHandler from '@/libs/error-handler';
import QrMenuApi from '@/api/QrMenuApi';

import IconLayers from '@/components/Icons/general/IconLayers.svg';

import formData from '@/views/pages/QrMenu/FormData/form-data-desk';

export default {
   name: 'ModalCategoryUpdate',
   i18n: {
      messages: {
         tr: {
            title: 'Masa Güncelleyin',
            subtitle: 'Masa bilgilerini girerek güncelleyebilirsiniz',
            form_title: 'Masa Bilgilerini Giriniz',
            fields: {
               title: 'Masa Adı',
               description: 'Açıklama',
               prefix: 'Ön Ek (Örn: Bahçe)',
               number_start: 'Başlangıç No',
               number_end: 'Bitiş No',
            },
            actions: {
               save: 'Kaydet',
            },
         },
         en: {
            title: 'Update Table',
            subtitle: 'You can update table information by entering table details.',
            form_title: 'Enter Table Information',
            fields: {
               title: 'Table Name',
               description: 'Description',
               prefix: 'Prefix (e.g., Garden)',
               number_start: 'Start Number',
               number_end: 'End Number',
            },
            actions: {
               save: 'Save',
            },
         },
      },
   },
   data() {
      return {
         IconLayers,
         isLoading: false,
         formData,
      };
   },
   methods: {
      show(data) {
         if (data !== null) {
            this.formData.merge(data.only('id', 'title', 'number_start', 'number_end', 'description', 'prefix'));
            this.$refs.modal.show();
         }
      },
      hide() {
         this.$refs.modal.hide();
      },
      async submitForm() {
         if (!this.formData.isValid({ disableDirtyCheck: true })) return;

         this.isLoading = true;

         try {
            const response = await QrMenuApi.desks.update(this.formData.id, this.formData.toObject());

            this.formData.reset();

            this.hide();
            this.$emit('success', response);
         } catch (err) {
            ErrorHandler.handle(err);

            this.$emit('failed', err);
         } finally {
            this.isLoading = false;

            this.$emit('end');
         }
      },
   },
};
</script>
